import styled from "styled-components";
import "../../styles/variables.css";

export const DialogContainer = styled.div`
  width: 484px;
  height: 100%;
  // max-height: 676px;
  padding: 32px 38px;
  border-radius: 16px;
  box-sizing: border-box;
  background: var(--bg-body);
  overflow-y: hidden;
  transition: all 0.24s ease;
  transform: scale(1);

  svg {
    cursor: pointer;
  }
  @media (max-width: 600px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0px;
  }
`;

export const DialogBackdrop = styled.div<{open: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(43, 45, 59, 0.8);
  overflow: hidden;
  transition: all 0.24s ease;
  opacity: 1;

  ${_ => !_.open && `
    opacity: 0;
    pointer-events: none;

    ${DialogContainer} {
      transform: scale(0);
    }
  `}
`;
